import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables, scales } from "chart.js";
import { Grid } from "@mui/material";

ChartJS.register(...registerables);

const HorizontalBar = ({
  data,
  percentage,
  title,
}: {
  data: any;
  percentage: any;
  title: string;
}) => {
  const options = {
    maintainAspectRatio: false,
    indexAxis: "y" as "y", // Assuming "y" is what you want
    elements: {
      bar: {
        borderWidth: 1,
        barThickness: 56, // Check this value
      },
    },

    scales: {
      y: {
        grid: {
          color: "#F2F4F7",
        },
        ticks: {
          crossAlign: "far" as const,
          font: {
            family: "Inter",
            size: 12,
            color: "#667085",
            weight: 400,
          },
          textAlign: "left",
          padding: 10,
        },
      },
      // x: {
      //   grid: {
      //     color: "#F2F4F7",
      //   },
      //   ticks: {
      //     font: {
      //       family: "Inter",
      //       size: 12,
      //       color: "#667085",
      //       weight: 400,
      //     },
      //     callback: function (value: any) {
      //       if (value >= 100000) {
      //         return value / 100000 + "Lac";
      //       } else if (value >= 1000) {
      //         return value / 1000 + "K";
      //       } else {
      //         return value;
      //       }
      //     },
      //   },
      // },
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 100000, // ✅ ONLY 1 Lac steps
          font: {
            family: "Inter",
            size: 12,
            weight: 400,
          },
          callback: function (value: any) {
            if (value === 0) return "0";
            return (value / 100000) + " Lac";
          },
        },
        grid: {
          color: "#F2F4F7",
        },
      },
    },

    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        position: "nearest" as "nearest",
        backgroundColor: "#FFFFFF",
        titleColor: "#101828",
        titleFont: {
          size: 14,
          weight: 600 as const,
          family: "Inter",
        },
        bodyColor: "#101828",
        boxPadding: 4,
        bodyFont: {
          size: 12,
          weight: 500 as const,
          family: "Inter",
        },
        padding: 10,
        cornerRadius: 6,
        borderColor: "#EAECF0",
        borderWidth: 2,
        callbacks: {
          label: function (context: any) {
            const label = context?.label;
            const value = context.formattedValue;
            return `${label}: ${value}`;
          },
          title: function (context: any) {
            return title;
          },
        },
      },
    },
  };

  return (
    <Grid container spacing={1} sx={{ height: "100%" }}>
      <Grid item xs={11} sm={11} md={11} sx={{ height: "100%" }}>
        <Bar data={data} options={options} />
      </Grid>
      <Grid item xs={1} sm={1} md={1}>
        <div className="flex flex-col h-[100%] justify-around items-center py-5">
          {percentage.map((item: any, index: number) => {
            return (
              <div className="text-12 text-secondary font-normal" key={index}>
                {item?.toFixed(2)}%
              </div>
            );
          })}
        </div>
      </Grid>
    </Grid>
  );
};
export default HorizontalBar;
